var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"showDesc":false,"showName":false,"hiddenKeys":['project_domain', 'tenant', 'created_at', 'updated_at'],"onManager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }